import React, { useState, useEffect } from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';

const StickyCTA = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past hero section (approx 600px)
      setIsVisible(window.scrollY > 600);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToPathway = () => {
    const element = document.querySelector('#pathway');
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  if (!isVisible) return null;

  return (
    <div className="sticky-cta-container">
      <div className="sticky-cta-inner">
        <a
          href="https://wa.me/9172096199"
          target="_blank"
          rel="noopener noreferrer"
          className="sticky-cta-btn btn-gold"
        >
          Start on WhatsApp
          <ArrowRight size={14} />
        </a>
        <button
          onClick={scrollToPathway}
          className="sticky-cta-btn btn-gold"
        >
          Choose Your Tier
          <ChevronDown size={14} />
        </button>
      </div>
    </div>
  );
};

export default StickyCTA;
